import { ErrorBox } from "../shared/error-box";
import { getErrorMessage } from "./utils";

/**
 * @param extraInfo - Extra information to display in the error message
 */
export function Timeout({ extraInfo }: { extraInfo?: string }) {
  return <ErrorBox>{getErrorMessage("timeout", extraInfo)}</ErrorBox>;
}
